<template>
  <BaseDialog :isOpen="isOpen">
    <template v-slot:title>
      Are you sure you want to delete this publishing Schedule?
    </template>
    <template v-slot:body>
      <p class="secondary-text">
        This cannot be undone.
      </p>
    </template>
    <template v-slot:actions>
      <div>
        <PrimaryButton @click.native="cancel" text>
          Cancel
        </PrimaryButton>
        <ErrorButton @click.native="handleSubmit" :loading="isLoading">
          Delete
        </ErrorButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import ErrorButton from "@/components/common/Button/ErrorButton";
import { DELETE_PUBLISHING_SCHEDULE } from "@/store/modules/organisations/organisation-schedules/actions";
import { ORGANISATION_SCHEDULES_NAMESPACE } from "@/store/modules/organisations/organisation-schedules";
import { createNamespacedHelpers } from "vuex";

const { mapActions } = createNamespacedHelpers(
  ORGANISATION_SCHEDULES_NAMESPACE
);

export default {
  components: { ErrorButton, PrimaryButton, BaseDialog },
  props: {
    isOpen: Boolean,
    publishingSchedule: Object
  },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    ...mapActions({
      deletePublishingSchedule: DELETE_PUBLISHING_SCHEDULE
    }),
    async handleSubmit() {
      this.isLoading = true;
      await this.deletePublishingSchedule(this.publishingSchedule.id);
      this.$emit("close");
      this.isLoading = false;
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.cancel-booking-description {
  min-height: 100px;
}
</style>
